import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'
import DeleteAction from 'core/actions/DeleteAction'
import { ClusterHostGroup, CreateClusterHostGroup } from './model'
import { cacheActions } from 'core/caching/cacheReducers'
import store from 'app/store'
import CustomAction from 'core/actions/CustomAction'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
// import { dummyHostClusters } from './dummyData'

const { resMgr } = ApiClient.getInstance()
const { dispatch } = store

export const resmgrClusterActions = ActionsSet.make<DataKeys.ClusterHostGroups>({
  uniqueIdentifier: 'name',
  entityName: entityNamesByKey[DataKeys.ClusterHostGroups],
  cacheKey: DataKeys.ClusterHostGroups,
})

export const listClusterHostGroups = resmgrClusterActions.add(
  new ListAction<DataKeys.ClusterHostGroups>(async () => {
    Bugsnag.leaveBreadcrumb('Attempting to get clusters')
    return resMgr.getClusterHostGroups()
  })
    .addDependency(DataKeys.ResmgrHosts)
    .addDependency(DataKeys.HostNetworkConfigs),
)

export const deleteClusterHostGroup = resmgrClusterActions.add(
  new DeleteAction<DataKeys.ClusterHostGroups, { name: string }>(async ({ name }) => {
    Bugsnag.leaveBreadcrumb('Attempting to delete cluster', { name })
    await resMgr.deleteClusterHostGroup({ name })
  }),
)

export const createClusterHostGroup = resmgrClusterActions.add(
  new CustomAction<DataKeys.ClusterHostGroups, { body: CreateClusterHostGroup }>(
    'createClusterHostGroup',
    async ({ body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create cluster', { body })
      const created: ClusterHostGroup = await resMgr.createClusterHostGroup({ body })
      trackEvent('Create New Cluster', {
        name: pathStr('name', created),
      })
      return created
    },
    (_, { body }) => {
      // Update the cluster in the cache
      dispatch(
        cacheActions.addItem({
          cacheKey: DataKeys.ClusterHostGroups,
          params: { name: body.name },
          item: body,
        }),
      )
    },
  ),
)

export const updateClusterHostGroup = resmgrClusterActions.add(
  new CustomAction<DataKeys.ClusterHostGroups, { body: CreateClusterHostGroup }>(
    'updateClusterHostGroup',
    async ({ body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to update cluster', { body })
      const updated: ClusterHostGroup = await resMgr.updateClusterHostGroup({
        name: body.name,
        body,
      })
      trackEvent('Update Cluster', {
        name: pathStr('name', updated),
      })

      return updated
    },
    (_, { body }) => {
      // Update the cluster in the cache
      dispatch(
        cacheActions.updateItem({
          uniqueIdentifier: 'name',
          cacheKey: DataKeys.ClusterHostGroups,
          params: { name: body.name },
          item: body,
        }),
      )
    },
  ),
)
